// hex (#rrggbb) -> "h s% l%" triplet used by hsl(var(--primary))
export function hexToHslTriplet(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
    if (!m) return null;
    const n = parseInt(m[1], 16);
    const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h = 0, s = 0;
    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
        h *= 60;
    }
    return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function productTone(content) {
    const style = {};
    if (content.pd_bg_color) style["--pd-bg"] = content.pd_bg_color;
    if (content.pd_panel_color) style["--pd-panel"] = content.pd_panel_color;
    if (content.pd_text_color) style["--pd-text"] = content.pd_text_color;
    if (content.pd_border_color) style["--pd-border"] = content.pd_border_color;
    const accent = hexToHslTriplet(content.pd_accent_color);
    if (accent) style["--primary"] = accent;
    return style;
}
